import React from 'react';
import { makeAutoObservable } from 'mobx';
import { AddPhoneStore } from '../../../../stores/premiumUsers2FaEnforcement/sms/addPhone';
import {
  StepDefinitions,
  Steps,
} from '../../../../stores/premiumUsers2FaEnforcement/sms/types';
import { BackTextButton } from '../OwnerApp/BackTextButton';

export class UiStore {
  public isBackupMethod: boolean = false;
  public showStepper: boolean = true;
  public messagePrefix: string = this.store.premiumUsers2FaEnforcementStore
    .postLoginStore.shouldShowWixAppEnforcement
    ? 'wixAppEnforcement.'
    : '';
  constructor(private store: AddPhoneStore) {
    makeAutoObservable(this);
    this.isBackupMethod =
      store.premiumUsers2FaEnforcementStore.ownerAppStore.waitingForBackupMethod;
    this.showStepper =
      this.isBackupMethod &&
      !this.store.premiumUsers2FaEnforcementStore.postLoginStore
        .shouldShowWixAppEnforcement;
  }

  translate(s?: string) {
    return s ? this.store.premiumUsers2FaEnforcementStore.t(s) : s;
  }

  get steps() {
    return this.isBackupMethod
      ? this.backupMethodSteps
      : this.initialMethodSteps;
  }

  get initialMethodSteps(): StepDefinitions {
    return {
      [Steps.AddPhoneStep]: {
        title: `post.login.mfa.phone.choose.title`,
        subtitle: `post.login.mfa.phone.choose.subtitle`,
        primaryButtonText:
          'add_phone_wizard.new_style.add_phone.confirm_button',
        primaryButtonOnClick: this.store.onSendVerificationSms,
        sideActions: (
          <BackTextButton
            goBack={
              this.store.premiumUsers2FaEnforcementStore
                .goBackToEnforcementOrChooseBackupMethod
            }
          />
        ),
        currentStep: undefined,
      },
      [Steps.ConfirmCodeStep]: {
        title: `${this.messagePrefix}post.login.mfa.phone.verify.title`,
        sideActions: (
          <BackTextButton goBack={this.store.onBackToPreviousStep} />
        ),
        currentStep: undefined,
      },
    };
  }

  get backupMethodSteps(): StepDefinitions {
    return {
      [Steps.AddPhoneStep]: {
        title: `${this.messagePrefix}add_phone_wizard.title`,
        subtitle: `${this.messagePrefix}add_phone_wizard.subtitle`,
        primaryButtonText:
          'add_phone_wizard.new_style.add_phone.confirm_button',
        primaryButtonOnClick: this.store.onSendVerificationSms,
        sideActions: (
          <BackTextButton
            goBack={
              this.store.premiumUsers2FaEnforcementStore
                .goBackToEnforcementOrChooseBackupMethod
            }
          />
        ),
        currentStep: undefined,
      },
      [Steps.ConfirmCodeStep]: {
        title: `${this.messagePrefix}add_phone_wizard.title`,
        subtitle: `${this.messagePrefix}add_phone_wizard.subtitle`,
        sideActions: (
          <BackTextButton goBack={this.store.onBackToPreviousStep} />
        ),
        currentStep: undefined,
      },
    };
  }

  get title() {
    return this.translate(this.steps[this.store.activeStep].title);
  }

  get subtitle() {
    return this.translate(this.steps[this.store.activeStep].subtitle);
  }

  get primaryButtonText() {
    return this.translate(this.steps[this.store.activeStep].primaryButtonText);
  }

  get primaryButtonOnClick() {
    return this.steps[this.store.activeStep].primaryButtonOnClick;
  }

  get sideActions() {
    return this.steps[this.store.activeStep].sideActions;
  }

  get backButtonCallback(): () => void {
    return this.store.activeStep === Steps.ConfirmCodeStep
      ? this.store.onBackToPreviousStep
      : this.store.premiumUsers2FaEnforcementStore
          .goBackToEnforcementOrChooseBackupMethod;
  }
}
